<template>
  <form>
    <div class="a-filter__body u-padding-top-24px">
      <div class="a-filter__block admin-filter__block">
        <div class="a-filter__label admin-filter__label">{{$t('form.user-search.registration-date.label')}}:</div>
        <div class="a-input-group ">
          <p>{{$t('form.user-search.registration-date.from.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker time="startOfDay" v-model="filters.period.from"></date-picker>
        </div>
        <div class="a-input-group ">
          <p>{{$t('form.user-search.registration-date.to.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker time="endOfDay" v-model="filters.period.to"></date-picker>
        </div>
      </div>

      <div class="a-container-form ">
        <div class="a-label a-label--w-215" v-t="'form.user-search.registration-date.user.label'"></div>
        <user-search class="select-w-570"
                     all-users-search
                     multiple
                     tags
                     :placeholder="$t('form.user-search.registration-date.user.placeholder')"
                     v-model="filters.users">
        </user-search>
      </div>

      <div class="a-container-form ">
        <div class="a-label a-label--w-215" v-t="'form.user-search.registration-date.organization.label'"></div>
        <organization-search class="select-w-570"
                             multiple
                             tags
                             :placeholder="$t('form.user-search.registration-date.organization.placeholder')"
                             v-model="filters.organizations">
        </organization-search>
      </div>

<!--      <div class="a-container-form ">-->
<!--        <div class="a-label a-label&#45;&#45;w-215">Главный пользователь</div>-->
<!--        <user-search class="select-w-570"-->
<!--                     main-organizer-->
<!--                     multiple-->
<!--                     tags-->
<!--                     :placeholder="$t('form.user-search.registration-date.user.placeholder')"-->
<!--                     v-model="filters.mainUsers">-->
<!--        </user-search>-->
<!--      </div>-->

      <div class="a-container-form ">
        <div class="a-label a-label--w-215">Аккредитация</div>
        <dropdown-new class="select-w-570"
                      :options="enums.AccreditationState.options.all"
                      v-model="filters.state">
        </dropdown-new>
      </div>

      <div class="a-container-form ">
        <div class="a-label a-label--w-215">Статус</div>
        <dropdown-new class="select-w-570"
                      :options="enums.UserAccreditationState.options.all"
                      v-model="filters.userAccreditationState">
        </dropdown-new>
      </div>
    </div>

    <div class="a-filter__footer ">
      <button class="gui-btn gui-btn--white-border gui-btn--w-167" type="button" @click="resetFilters" v-t="'buttons.reset-filters'"></button>
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="fetchUsers" v-t="'buttons.apply'"></button>
    </div>
  </form>
</template>

<script>
  import DepartmentSearch from '@/components/common/inputs/DepartmentSearch'
  import OrganizationSearch from '@/components/common/inputs/OrganizationSearch'
  import UserSearch from '@/components/common/inputs/UserSearch'

  export default {
    components: {
      OrganizationSearch,
      DepartmentSearch,
      UserSearch
    },

    data: function() {
      return {
        loading: false,
        filters: {
          customer: undefined,
          participant: undefined,
          main: undefined,
          commission: undefined,
          state: undefined,
          userAccreditationState: undefined,
          userStates: undefined,
          period: {
            from: undefined,
            to: undefined
          },
          departments: [],
          organizations: [],
          users: [],
          mainUsers: []
        }
      }
    },

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions;
      }
    },

    methods: {
      async fetchUsers() {
        this.runAction(async () => {
          try {
            this.filters.customer = true;

            await this.$store.dispatch('fetchUsers', {
              from: this.filters.period.from,
              to: this.filters.period.to,
              showContractorUsers: true,
              users: (this.filters.users || []).map(e => e.id),
              organizations: (this.filters.organizations || []).map(e => e.id),
              userStates: (this.filters.userStates || []).map(e => e.id),
              state: this.filters.state,
              userAccreditationState: this.filters.userAccreditationState
            })
          }
          catch(e) {
            console.error('unable to fetch list of users', e);
            this.globalErrorHandler(e);
          }
        });
      },

      resetFilters() {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    }
  }
</script>

<style scoped>

</style>
